import React, { Component } from "react";
import { Row, Col, Nav, Stack } from "react-bootstrap";
import { Link } from "react-router-dom";
import CartContext from "./CartContext";
import { Testimonial1 } from "./Home";
import { ClientsSlider } from "./Home";

export class Footer extends Component {
  static contextType = CartContext;

  render() {
    return (
      <>
        <br />
        {/* Facts Section */}

        {/* Testimonials & Clients */}
        {/* <Testimonial1 />
        <ClientsSlider /> */}

        {/* Footer Section */}
        <footer className="container-fluid bg-light mt-5 py-5">
          <div className="container pt-5">
            <div className="row g-5">
              {/* Contact Info */}
              <div className="col-lg-4 col-md-6">
                <h5 className="text-uppercase border-start border-5 border-primary ps-3 mb-4">
                  Get In Touch
                </h5>
                <p className="mb-2">
                  <i className="bi bi-geo-alt text-primary me-2"></i>
                  SANTREZA IT Solutions Private Limited, #230, Kammasandra Road,
                  Electronic City, Bangalore, KA, India 560100.
                </p>
                <p className="mb-2">
                  <i className="bi bi-envelope-open text-primary me-2"></i>
                  support@elasticcart.com
                </p>
                <p className="mb-0">
                  <i className="bi bi-telephone text-primary me-2"></i>
                  +91-9880582728
                </p>
                <p className="mb-0">
                  <i className="bi bi-whatsapp text-primary me-2"></i>
                  <a
                    className="text-dark"
                    href="https://wa.me/919880582728"
                    target="_blank"
                  >
                    +91 9880582728
                  </a>
                </p>
              </div>

              {/* Quick Links */}
              {/* <div className="col-lg-3 col-md-6">
                <h5 className="text-uppercase border-start border-5 border-primary ps-3 mb-4">
                  Quick Links
                </h5>
                <div className="d-flex flex-column justify-content-start">
                  {[
                    "Home",
                    "About Us",
                    "Our Services",
                    "Meet The Team",
                    "Contact Us",
                  ].map((text, i) => (
                    <a key={i} className="text-body mb-2" href="#">
                      <i className="bi bi-arrow-right text-primary me-2"></i>
                      {text}
                    </a>
                  ))}
                </div>
              </div> */}

              {/* Popular Links */}
              <div className="col-lg-4 col-md-6">
                <h5 className="text-uppercase border-start border-5 border-primary ps-3 mb-4">
                  Popular Links
                </h5>
                <div className="d-flex flex-column justify-content-start">
                  <a className="text-body mb-2" href="/Home">
                    <i className="bi bi-arrow-right text-primary me-2"></i>Home
                  </a>
                  {/* <a className="text-body mb-2" href="/Home">
                    <i className="bi bi-arrow-right text-primary me-2"></i>
                    Products
                  </a>
                  <a className="text-body mb-2" href="/Home">
                    <i className="bi bi-arrow-right text-primary me-2"></i>
                    Solutions
                  </a>
                  <a className="text-body mb-2" href="/Home">
                    <i className="bi bi-arrow-right text-primary me-2"></i>
                    Services
                  </a> */}
                  {/* <a className="text-body mb-2" href="#">
                    <i className="bi bi-arrow-right text-primary me-2"></i>About
                    Us
                  </a> */}
                  <a className="text-body mb-2" href="/showcase">
                    <i className="bi bi-arrow-right text-primary me-2"></i>
                    Showcases
                  </a>
                  {/* <a className="text-body mb-2" href="/themes">
                    <i className="bi bi-arrow-right text-primary me-2"></i>
                    Themes
                  </a> */}
                  <a className="text-body" href="/pricing">
                    <i className="bi bi-arrow-right text-primary me-2"></i>
                    Pricing
                  </a>
                </div>
              </div>

              {/* Newsletter & Socials */}
              <div className="col-lg-4 col-md-6">
                <h5 className="text-uppercase border-start border-5 border-primary ps-3 mb-4">
                  Newsletter
                </h5>
                <form onSubmit={(e) => e.preventDefault()}>
                  <div className="input-group">
                    <input
                      type="email"
                      className="form-control p-3"
                      placeholder="Your Email"
                      required
                    />
                    <button className="btn btn-primary" type="submit">
                      Sign Up
                    </button>
                  </div>
                </form>
                <Link className="d-block mt-3" to="/VisitorsCount">
                  {/* <i className="bi bi-arrow-right me-2"></i>Visitors Count */}
                  <i className="bi bi-arrow-right me-2"></i>VC
                </Link>
                <h6 className="text-uppercase mt-4 mb-3">Follow Us</h6>
                <div className="d-flex">
                  {[
                    { icon: "twitter", url: "https://twitter.com/ElasticCART" },
                    {
                      icon: "facebook",
                      url: "https://www.facebook.com/ElasticCart1/",
                    },
                    {
                      icon: "youtube",
                      url: "https://www.youtube.com/@ElasticCart",
                    },
                    {
                      icon: "linkedin",
                      url: "https://www.linkedin.com/in/ElasticCART-pos-and-ecommerce-aa697a272/",
                    },
                    {
                      icon: "instagram",
                      url: "https://www.instagram.com/ElasticCART/",
                    },
                  ].map(({ icon, url }) => (
                    <a
                      key={icon}
                      className="btn btn-outline-primary btn-square me-2"
                      href={url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className={`bi bi-${icon}`}></i>
                    </a>
                  ))}
                </div>
              </div>

              {/* Legal & Footer Links */}
              <div className="col-12 text-center text-body mt-4">
                {/* <a
                  className="text-body"
                  href="https://ecprdstorage01.blob.core.windows.net/elasticcart/Terms of Service.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Terms & Conditions
                </a> */}
                <Stack
                  direction="horizontal"
                  className="justify-content-center"
                >
                  <Nav.Link
                    as={Link}
                    to="/TermsAndConditions"
                    className=""
                    target="_blank"
                  >
                    <u>Terms & Conditions</u>
                  </Nav.Link>
                  <span className="mx-1">|</span>
                  <Nav.Link
                    as={Link}
                    to="/PrivacyPolicy"
                    target="_blank"
                    className=""
                  >
                    <u>Privacy Policy</u>
                  </Nav.Link>
                  <span className="mx-1">|</span>
                  <Nav.Link
                    as={Link}
                    to="/ContactUs"
                    target="_blank"
                    className=""
                  >
                    <u>Contact Us</u>
                  </Nav.Link>
                </Stack>
              </div>
            </div>
          </div>
        </footer>

        {/* Copyright */}
        <div className="container-fluid bg-white text-white-50 py-4">
          <div className="container">
            <div className="row g-5">
              <div className="col-md-6 text-center text-md-start">
                <p className="mb-md-0">
                  &copy;{" "}
                  <a className="text-white" href="#">
                    ElasticCART
                  </a>
                  . All Rights Reserved.
                </p>
              </div>
              <div className="col-md-6 text-center text-md-end">
                <p className="mb-0">
                  Designed by{" "}
                  <a className="text-white" href="https://htmlcodex.com">
                    HTML Codex
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Back to Top */}
        <a href="#" className="btn btn-primary py-3 fs-4 back-to-top">
          <i className="bi bi-arrow-up"></i>
        </a>
      </>
    );
  }
}

export default Footer;
